module.exports = __webpack_public_path__ + "img/Bear06.116902b1.jpg";